import cn from 'classnames';
import { ColumnDef } from '@tanstack/react-table';
import {
  getNotificationCreatedByLabel,
  type INotification,
} from '@/entities/Notifications';
import TrashIcon from '@/shared/assets/icons/trash.svg';
import { convertIsoToDate, convertIsoToTime } from '@/shared/lib/utils/dateAdapters';
import { Svg } from '@/shared/ui/Svg';

export const pushNotificationsColumns = (
  onDelete: (notification: INotification) => void,
): ColumnDef<INotification>[] => [
  {
    id: 'title',
    header: 'Notification Title',
    accessorKey: 'title',
    cell: ({ row }) => (
      <span
        className={cn('text-black-headline', {
          'font-semibold': !row.original.isRead,
          'font-medium': row.original.isRead,
        })}
      >
        {row.original.title}
      </span>
    ),
  },
  {
    id: 'timeSent',
    header: 'Time Sent',
    accessorKey: 'createdAt',
    cell: ({ row }) => (
      <div className="flex flex-col text-black-headline">
        <span>{convertIsoToDate(row.original.createdAt)}</span>
        <span className="text-grey">{convertIsoToTime(row.original.createdAt)}</span>
      </div>
    ),
  },
  {
    id: 'message',
    header: 'Message Text',
    accessorKey: 'message',
    cell: ({ row }) => (
      <p className="text-black-headline max-w-[420px] truncate">{row.original.message}</p>
    ),
  },
  {
    id: 'createdBy',
    header: 'Created by',
    accessorKey: 'createdByUser',
    cell: ({ row }) => (
      <span className="text-black-headline">
        {getNotificationCreatedByLabel(row.original.createdByUser)}
      </span>
    ),
  },
  {
    id: 'actions',
    header: () => null,
    cell: ({ row }) => (
      <button
        type="button"
        className="cursor-pointer p-2"
        aria-label="Delete notification"
        onClick={(event) => {
          event.stopPropagation();
          onDelete(row.original);
        }}
      >
        <Svg Icon={TrashIcon} className="h-5 w-5 text-red-tertiary" />
      </button>
    ),
  },
];
